// STANDALONE COUNTRY DATA FOR PHONEINPUT
// Auto-generated from material-ui-phone-number/src/country_data.js

export const countries = [
  {
    "name": "Afghanistan",
    "iso2": "af",
    "dialCode": "93",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇫"
  },
  {
    "name": "Albania",
    "iso2": "al",
    "dialCode": "355",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇱"
  },
  {
    "name": "Algeria",
    "iso2": "dz",
    "dialCode": "213",
    "format": null,
    "isAreaCode": false,
    "flag": "🇩🇿"
  },
  {
    "name": "American Samoa",
    "iso2": "as",
    "dialCode": "1684",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇸"
  },
  {
    "name": "Andorra",
    "iso2": "ad",
    "dialCode": "376",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇩"
  },
  {
    "name": "Angola",
    "iso2": "ao",
    "dialCode": "244",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇴"
  },
  {
    "name": "Anguilla",
    "iso2": "ai",
    "dialCode": "1264",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇮"
  },
  {
    "name": "Antigua and Barbuda",
    "iso2": "ag",
    "dialCode": "1268",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇬"
  },
  {
    "name": "Argentina",
    "iso2": "ar",
    "dialCode": "54",
    "format": "+.. (..) ........",
    "isAreaCode": false,
    "flag": "🇦🇷"
  },
  {
    "name": "Armenia",
    "iso2": "am",
    "dialCode": "374",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇲"
  },
  {
    "name": "Aruba",
    "iso2": "aw",
    "dialCode": "297",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇼"
  },
  {
    "name": "Australia",
    "iso2": "au",
    "dialCode": "61",
    "format": "+.. ... ... ...",
    "isAreaCode": false,
    "flag": "🇦🇺"
  },
  {
    "name": "Austria",
    "iso2": "at",
    "dialCode": "43",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇹"
  },
  {
    "name": "Azerbaijan",
    "iso2": "az",
    "dialCode": "994",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇿"
  },
  {
    "name": "Bahamas",
    "iso2": "bs",
    "dialCode": "1242",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇸"
  },
  {
    "name": "Bahrain",
    "iso2": "bh",
    "dialCode": "973",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇭"
  },
  {
    "name": "Bangladesh",
    "iso2": "bd",
    "dialCode": "880",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇩"
  },
  {
    "name": "Barbados",
    "iso2": "bb",
    "dialCode": "1246",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇧"
  },
  {
    "name": "Belarus",
    "iso2": "by",
    "dialCode": "375",
    "format": "+... (..) ... .. ..",
    "isAreaCode": false,
    "flag": "🇧🇾"
  },
  {
    "name": "Belgium",
    "iso2": "be",
    "dialCode": "32",
    "format": "+.. ... .. .. ..",
    "isAreaCode": false,
    "flag": "🇧🇪"
  },
  {
    "name": "Belize",
    "iso2": "bz",
    "dialCode": "501",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇿"
  },
  {
    "name": "Benin",
    "iso2": "bj",
    "dialCode": "229",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇯"
  },
  {
    "name": "Bermuda",
    "iso2": "bm",
    "dialCode": "1441",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇲"
  },
  {
    "name": "Bhutan",
    "iso2": "bt",
    "dialCode": "975",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇹"
  },
  {
    "name": "Bolivia",
    "iso2": "bo",
    "dialCode": "591",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇴"
  },
  {
    "name": "Bosnia and Herzegovina",
    "iso2": "ba",
    "dialCode": "387",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇦"
  },
  {
    "name": "Botswana",
    "iso2": "bw",
    "dialCode": "267",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇼"
  },
  {
    "name": "Brazil",
    "iso2": "br",
    "dialCode": "55",
    "format": "+.. (..) .........",
    "isAreaCode": false,
    "flag": "🇧🇷"
  },
  {
    "name": "British Indian Ocean Territory",
    "iso2": "io",
    "dialCode": "246",
    "format": null,
    "isAreaCode": false,
    "flag": "🇮🇴"
  },
  {
    "name": "British Virgin Islands",
    "iso2": "vg",
    "dialCode": "1284",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇬"
  },
  {
    "name": "Brunei",
    "iso2": "bn",
    "dialCode": "673",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇳"
  },
  {
    "name": "Bulgaria",
    "iso2": "bg",
    "dialCode": "359",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇬"
  },
  {
    "name": "Burkina Faso",
    "iso2": "bf",
    "dialCode": "226",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇫"
  },
  {
    "name": "Burundi",
    "iso2": "bi",
    "dialCode": "257",
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇮"
  },
  {
    "name": "Cambodia",
    "iso2": "kh",
    "dialCode": "855",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇭"
  },
  {
    "name": "Cameroon",
    "iso2": "cm",
    "dialCode": "237",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇲"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": false,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1204",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1236",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1249",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1250",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1289",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1306",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1343",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1365",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1387",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1403",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1416",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1418",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1431",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1437",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1438",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1450",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1506",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1514",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1519",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1548",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1579",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1581",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1587",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1604",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1613",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1639",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1647",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1672",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1705",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1709",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1742",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1778",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1780",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1782",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1807",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1819",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1825",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1867",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1873",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1902",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Canada",
    "iso2": "ca",
    "dialCode": "1905",
    "priority": 1,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇨🇦"
  },
  {
    "name": "Cape Verde",
    "iso2": "cv",
    "dialCode": "238",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇻"
  },
  {
    "name": "Caribbean Netherlands",
    "iso2": "bq",
    "dialCode": "599",
    "priority": 1,
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇶"
  },
  {
    "name": "Cayman Islands",
    "iso2": "ky",
    "dialCode": "1345",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇾"
  },
  {
    "name": "Central African Republic",
    "iso2": "cf",
    "dialCode": "236",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇫"
  },
  {
    "name": "Chad",
    "iso2": "td",
    "dialCode": "235",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇩"
  },
  {
    "name": "Chile",
    "iso2": "cl",
    "dialCode": "56",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇱"
  },
  {
    "name": "China",
    "iso2": "cn",
    "dialCode": "86",
    "format": "+.. ..-.........",
    "isAreaCode": false,
    "flag": "🇨🇳"
  },
  {
    "name": "Colombia",
    "iso2": "co",
    "dialCode": "57",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇴"
  },
  {
    "name": "Comoros",
    "iso2": "km",
    "dialCode": "269",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇲"
  },
  {
    "name": "Congo",
    "iso2": "cd",
    "dialCode": "243",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇩"
  },
  {
    "name": "Congo",
    "iso2": "cg",
    "dialCode": "242",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇬"
  },
  {
    "name": "Cook Islands",
    "iso2": "ck",
    "dialCode": "682",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇰"
  },
  {
    "name": "Costa Rica",
    "iso2": "cr",
    "dialCode": "506",
    "format": "+... ....-....",
    "isAreaCode": false,
    "flag": "🇨🇷"
  },
  {
    "name": "Côte d’Ivoire",
    "iso2": "ci",
    "dialCode": "225",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇮"
  },
  {
    "name": "Croatia",
    "iso2": "hr",
    "dialCode": "385",
    "format": null,
    "isAreaCode": false,
    "flag": "🇭🇷"
  },
  {
    "name": "Cuba",
    "iso2": "cu",
    "dialCode": "53",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇺"
  },
  {
    "name": "Curaçao",
    "iso2": "cw",
    "dialCode": "599",
    "priority": 0,
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇼"
  },
  {
    "name": "Cyprus",
    "iso2": "cy",
    "dialCode": "357",
    "format": "+... .. ......",
    "isAreaCode": false,
    "flag": "🇨🇾"
  },
  {
    "name": "Czech Republic",
    "iso2": "cz",
    "dialCode": "420",
    "format": null,
    "isAreaCode": false,
    "flag": "🇨🇿"
  },
  {
    "name": "Denmark",
    "iso2": "dk",
    "dialCode": "45",
    "format": "+.. .. .. .. ..",
    "isAreaCode": false,
    "flag": "🇩🇰"
  },
  {
    "name": "Djibouti",
    "iso2": "dj",
    "dialCode": "253",
    "format": null,
    "isAreaCode": false,
    "flag": "🇩🇯"
  },
  {
    "name": "Dominica",
    "iso2": "dm",
    "dialCode": "1767",
    "format": null,
    "isAreaCode": false,
    "flag": "🇩🇲"
  },
  {
    "name": "Dominican Republic",
    "iso2": "do",
    "dialCode": "1",
    "priority": 2,
    "format": null,
    "isAreaCode": false,
    "flag": "🇩🇴"
  },
  {
    "name": "Dominican Republic",
    "iso2": "do",
    "dialCode": "1809",
    "priority": 2,
    "format": null,
    "isAreaCode": true,
    "flag": "🇩🇴"
  },
  {
    "name": "Dominican Republic",
    "iso2": "do",
    "dialCode": "1829",
    "priority": 2,
    "format": null,
    "isAreaCode": true,
    "flag": "🇩🇴"
  },
  {
    "name": "Dominican Republic",
    "iso2": "do",
    "dialCode": "1849",
    "priority": 2,
    "format": null,
    "isAreaCode": true,
    "flag": "🇩🇴"
  },
  {
    "name": "Ecuador",
    "iso2": "ec",
    "dialCode": "593",
    "format": null,
    "isAreaCode": false,
    "flag": "🇪🇨"
  },
  {
    "name": "Egypt",
    "iso2": "eg",
    "dialCode": "20",
    "format": null,
    "isAreaCode": false,
    "flag": "🇪🇬"
  },
  {
    "name": "El Salvador",
    "iso2": "sv",
    "dialCode": "503",
    "format": "+... ....-....",
    "isAreaCode": false,
    "flag": "🇸🇻"
  },
  {
    "name": "Equatorial Guinea",
    "iso2": "gq",
    "dialCode": "240",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇶"
  },
  {
    "name": "Eritrea",
    "iso2": "er",
    "dialCode": "291",
    "format": null,
    "isAreaCode": false,
    "flag": "🇪🇷"
  },
  {
    "name": "Estonia",
    "iso2": "ee",
    "dialCode": "372",
    "format": "+... .... ......",
    "isAreaCode": false,
    "flag": "🇪🇪"
  },
  {
    "name": "Ethiopia",
    "iso2": "et",
    "dialCode": "251",
    "format": null,
    "isAreaCode": false,
    "flag": "🇪🇹"
  },
  {
    "name": "Falkland Islands",
    "iso2": "fk",
    "dialCode": "500",
    "format": null,
    "isAreaCode": false,
    "flag": "🇫🇰"
  },
  {
    "name": "Faroe Islands",
    "iso2": "fo",
    "dialCode": "298",
    "format": null,
    "isAreaCode": false,
    "flag": "🇫🇴"
  },
  {
    "name": "Fiji",
    "iso2": "fj",
    "dialCode": "679",
    "format": null,
    "isAreaCode": false,
    "flag": "🇫🇯"
  },
  {
    "name": "Finland",
    "iso2": "fi",
    "dialCode": "358",
    "format": "+... .. ... .. ..",
    "isAreaCode": false,
    "flag": "🇫🇮"
  },
  {
    "name": "France",
    "iso2": "fr",
    "dialCode": "33",
    "format": "+.. . .. .. .. ..",
    "isAreaCode": false,
    "flag": "🇫🇷"
  },
  {
    "name": "French Guiana",
    "iso2": "gf",
    "dialCode": "594",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇫"
  },
  {
    "name": "French Polynesia",
    "iso2": "pf",
    "dialCode": "689",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇫"
  },
  {
    "name": "Gabon",
    "iso2": "ga",
    "dialCode": "241",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇦"
  },
  {
    "name": "Gambia",
    "iso2": "gm",
    "dialCode": "220",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇲"
  },
  {
    "name": "Georgia",
    "iso2": "ge",
    "dialCode": "995",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇪"
  },
  {
    "name": "Germany",
    "iso2": "de",
    "dialCode": "49",
    "format": "+.. .... ........",
    "isAreaCode": false,
    "flag": "🇩🇪"
  },
  {
    "name": "Ghana",
    "iso2": "gh",
    "dialCode": "233",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇭"
  },
  {
    "name": "Gibraltar",
    "iso2": "gi",
    "dialCode": "350",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇮"
  },
  {
    "name": "Greece",
    "iso2": "gr",
    "dialCode": "30",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇷"
  },
  {
    "name": "Greenland",
    "iso2": "gl",
    "dialCode": "299",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇱"
  },
  {
    "name": "Grenada",
    "iso2": "gd",
    "dialCode": "1473",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇩"
  },
  {
    "name": "Guadeloupe",
    "iso2": "gp",
    "dialCode": "590",
    "priority": 0,
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇵"
  },
  {
    "name": "Guam",
    "iso2": "gu",
    "dialCode": "1671",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇺"
  },
  {
    "name": "Guatemala",
    "iso2": "gt",
    "dialCode": "502",
    "format": "+... ....-....",
    "isAreaCode": false,
    "flag": "🇬🇹"
  },
  {
    "name": "Guinea",
    "iso2": "gn",
    "dialCode": "224",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇳"
  },
  {
    "name": "Guinea-Bissau",
    "iso2": "gw",
    "dialCode": "245",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇼"
  },
  {
    "name": "Guyana",
    "iso2": "gy",
    "dialCode": "592",
    "format": null,
    "isAreaCode": false,
    "flag": "🇬🇾"
  },
  {
    "name": "Haiti",
    "iso2": "ht",
    "dialCode": "509",
    "format": "+... ....-....",
    "isAreaCode": false,
    "flag": "🇭🇹"
  },
  {
    "name": "Honduras",
    "iso2": "hn",
    "dialCode": "504",
    "format": null,
    "isAreaCode": false,
    "flag": "🇭🇳"
  },
  {
    "name": "Hong Kong",
    "iso2": "hk",
    "dialCode": "852",
    "format": "+... .... ....",
    "isAreaCode": false,
    "flag": "🇭🇰"
  },
  {
    "name": "Hungary",
    "iso2": "hu",
    "dialCode": "36",
    "format": null,
    "isAreaCode": false,
    "flag": "🇭🇺"
  },
  {
    "name": "Iceland",
    "iso2": "is",
    "dialCode": "354",
    "format": "+... ... ....",
    "isAreaCode": false,
    "flag": "🇮🇸"
  },
  {
    "name": "India",
    "iso2": "in",
    "dialCode": "91",
    "format": "+.. .....-.....",
    "isAreaCode": false,
    "flag": "🇮🇳"
  },
  {
    "name": "Indonesia",
    "iso2": "id",
    "dialCode": "62",
    "format": null,
    "isAreaCode": false,
    "flag": "🇮🇩"
  },
  {
    "name": "Iran",
    "iso2": "ir",
    "dialCode": "98",
    "format": null,
    "isAreaCode": false,
    "flag": "🇮🇷"
  },
  {
    "name": "Iraq",
    "iso2": "iq",
    "dialCode": "964",
    "format": null,
    "isAreaCode": false,
    "flag": "🇮🇶"
  },
  {
    "name": "Ireland",
    "iso2": "ie",
    "dialCode": "353",
    "format": "+... .. .......",
    "isAreaCode": false,
    "flag": "🇮🇪"
  },
  {
    "name": "Israel",
    "iso2": "il",
    "dialCode": "972",
    "format": "+... ... ... ....",
    "isAreaCode": false,
    "flag": "🇮🇱"
  },
  {
    "name": "Italy",
    "iso2": "it",
    "dialCode": "39",
    "priority": 0,
    "format": "+.. ... .......",
    "isAreaCode": false,
    "flag": "🇮🇹"
  },
  {
    "name": "Jamaica",
    "iso2": "jm",
    "dialCode": "1876",
    "format": null,
    "isAreaCode": false,
    "flag": "🇯🇲"
  },
  {
    "name": "Japan",
    "iso2": "jp",
    "dialCode": "81",
    "format": "+.. .. .... ....",
    "isAreaCode": false,
    "flag": "🇯🇵"
  },
  {
    "name": "Jordan",
    "iso2": "jo",
    "dialCode": "962",
    "format": null,
    "isAreaCode": false,
    "flag": "🇯🇴"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": false,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7313",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7327",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "77172",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7312",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "773622",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7321",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7324",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7336",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7318",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7315",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7325",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7311",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7326",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kazakhstan",
    "iso2": "kz",
    "dialCode": "7310",
    "priority": 1,
    "format": "+. ... ...-..-..",
    "isAreaCode": true,
    "flag": "🇰🇿"
  },
  {
    "name": "Kenya",
    "iso2": "ke",
    "dialCode": "254",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇪"
  },
  {
    "name": "Kiribati",
    "iso2": "ki",
    "dialCode": "686",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇮"
  },
  {
    "name": "Kuwait",
    "iso2": "kw",
    "dialCode": "965",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇼"
  },
  {
    "name": "Kyrgyzstan",
    "iso2": "kg",
    "dialCode": "996",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇬"
  },
  {
    "name": "Laos",
    "iso2": "la",
    "dialCode": "856",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇦"
  },
  {
    "name": "Latvia",
    "iso2": "lv",
    "dialCode": "371",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇻"
  },
  {
    "name": "Lebanon",
    "iso2": "lb",
    "dialCode": "961",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇧"
  },
  {
    "name": "Lesotho",
    "iso2": "ls",
    "dialCode": "266",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇸"
  },
  {
    "name": "Liberia",
    "iso2": "lr",
    "dialCode": "231",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇷"
  },
  {
    "name": "Libya",
    "iso2": "ly",
    "dialCode": "218",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇾"
  },
  {
    "name": "Liechtenstein",
    "iso2": "li",
    "dialCode": "423",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇮"
  },
  {
    "name": "Lithuania",
    "iso2": "lt",
    "dialCode": "370",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇹"
  },
  {
    "name": "Luxembourg",
    "iso2": "lu",
    "dialCode": "352",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇺"
  },
  {
    "name": "Macau",
    "iso2": "mo",
    "dialCode": "853",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇴"
  },
  {
    "name": "Macedonia",
    "iso2": "mk",
    "dialCode": "389",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇰"
  },
  {
    "name": "Madagascar",
    "iso2": "mg",
    "dialCode": "261",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇬"
  },
  {
    "name": "Malawi",
    "iso2": "mw",
    "dialCode": "265",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇼"
  },
  {
    "name": "Malaysia",
    "iso2": "my",
    "dialCode": "60",
    "format": "+.. ..-....-....",
    "isAreaCode": false,
    "flag": "🇲🇾"
  },
  {
    "name": "Maldives",
    "iso2": "mv",
    "dialCode": "960",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇻"
  },
  {
    "name": "Mali",
    "iso2": "ml",
    "dialCode": "223",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇱"
  },
  {
    "name": "Malta",
    "iso2": "mt",
    "dialCode": "356",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇹"
  },
  {
    "name": "Marshall Islands",
    "iso2": "mh",
    "dialCode": "692",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇭"
  },
  {
    "name": "Martinique",
    "iso2": "mq",
    "dialCode": "596",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇶"
  },
  {
    "name": "Mauritania",
    "iso2": "mr",
    "dialCode": "222",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇷"
  },
  {
    "name": "Mauritius",
    "iso2": "mu",
    "dialCode": "230",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇺"
  },
  {
    "name": "Mexico",
    "iso2": "mx",
    "dialCode": "52",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇽"
  },
  {
    "name": "Micronesia",
    "iso2": "fm",
    "dialCode": "691",
    "format": null,
    "isAreaCode": false,
    "flag": "🇫🇲"
  },
  {
    "name": "Moldova",
    "iso2": "md",
    "dialCode": "373",
    "format": "+... (..) ..-..-..",
    "isAreaCode": false,
    "flag": "🇲🇩"
  },
  {
    "name": "Monaco",
    "iso2": "mc",
    "dialCode": "377",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇨"
  },
  {
    "name": "Mongolia",
    "iso2": "mn",
    "dialCode": "976",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇳"
  },
  {
    "name": "Montenegro",
    "iso2": "me",
    "dialCode": "382",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇪"
  },
  {
    "name": "Montserrat",
    "iso2": "ms",
    "dialCode": "1664",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇸"
  },
  {
    "name": "Morocco",
    "iso2": "ma",
    "dialCode": "212",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇦"
  },
  {
    "name": "Mozambique",
    "iso2": "mz",
    "dialCode": "258",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇿"
  },
  {
    "name": "Myanmar",
    "iso2": "mm",
    "dialCode": "95",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇲"
  },
  {
    "name": "Namibia",
    "iso2": "na",
    "dialCode": "264",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇦"
  },
  {
    "name": "Nauru",
    "iso2": "nr",
    "dialCode": "674",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇷"
  },
  {
    "name": "Nepal",
    "iso2": "np",
    "dialCode": "977",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇵"
  },
  {
    "name": "Netherlands",
    "iso2": "nl",
    "dialCode": "31",
    "format": "+.. .. ........",
    "isAreaCode": false,
    "flag": "🇳🇱"
  },
  {
    "name": "New Caledonia",
    "iso2": "nc",
    "dialCode": "687",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇨"
  },
  {
    "name": "New Zealand",
    "iso2": "nz",
    "dialCode": "64",
    "format": "+.. ...-...-....",
    "isAreaCode": false,
    "flag": "🇳🇿"
  },
  {
    "name": "Nicaragua",
    "iso2": "ni",
    "dialCode": "505",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇮"
  },
  {
    "name": "Niger",
    "iso2": "ne",
    "dialCode": "227",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇪"
  },
  {
    "name": "Nigeria",
    "iso2": "ng",
    "dialCode": "234",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇬"
  },
  {
    "name": "Niue",
    "iso2": "nu",
    "dialCode": "683",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇺"
  },
  {
    "name": "Norfolk Island",
    "iso2": "nf",
    "dialCode": "672",
    "format": null,
    "isAreaCode": false,
    "flag": "🇳🇫"
  },
  {
    "name": "North Korea",
    "iso2": "kp",
    "dialCode": "850",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇵"
  },
  {
    "name": "Northern Mariana Islands",
    "iso2": "mp",
    "dialCode": "1670",
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇵"
  },
  {
    "name": "Norway",
    "iso2": "no",
    "dialCode": "47",
    "format": "+.. ... .. ...",
    "isAreaCode": false,
    "flag": "🇳🇴"
  },
  {
    "name": "Oman",
    "iso2": "om",
    "dialCode": "968",
    "format": null,
    "isAreaCode": false,
    "flag": "🇴🇲"
  },
  {
    "name": "Pakistan",
    "iso2": "pk",
    "dialCode": "92",
    "format": "+.. ...-.......",
    "isAreaCode": false,
    "flag": "🇵🇰"
  },
  {
    "name": "Palau",
    "iso2": "pw",
    "dialCode": "680",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇼"
  },
  {
    "name": "Palestine",
    "iso2": "ps",
    "dialCode": "970",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇸"
  },
  {
    "name": "Panama",
    "iso2": "pa",
    "dialCode": "507",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇦"
  },
  {
    "name": "Papua New Guinea",
    "iso2": "pg",
    "dialCode": "675",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇬"
  },
  {
    "name": "Paraguay",
    "iso2": "py",
    "dialCode": "595",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇾"
  },
  {
    "name": "Peru",
    "iso2": "pe",
    "dialCode": "51",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇪"
  },
  {
    "name": "Philippines",
    "iso2": "ph",
    "dialCode": "63",
    "format": "+.. .... .......",
    "isAreaCode": false,
    "flag": "🇵🇭"
  },
  {
    "name": "Poland",
    "iso2": "pl",
    "dialCode": "48",
    "format": "+.. ...-...-...",
    "isAreaCode": false,
    "flag": "🇵🇱"
  },
  {
    "name": "Portugal",
    "iso2": "pt",
    "dialCode": "351",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇹"
  },
  {
    "name": "Puerto Rico",
    "iso2": "pr",
    "dialCode": "1",
    "priority": 3,
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇷"
  },
  {
    "name": "Puerto Rico",
    "iso2": "pr",
    "dialCode": "1787",
    "priority": 3,
    "format": null,
    "isAreaCode": true,
    "flag": "🇵🇷"
  },
  {
    "name": "Puerto Rico",
    "iso2": "pr",
    "dialCode": "1939",
    "priority": 3,
    "format": null,
    "isAreaCode": true,
    "flag": "🇵🇷"
  },
  {
    "name": "Qatar",
    "iso2": "qa",
    "dialCode": "974",
    "format": null,
    "isAreaCode": false,
    "flag": "🇶🇦"
  },
  {
    "name": "Réunion",
    "iso2": "re",
    "dialCode": "262",
    "format": null,
    "isAreaCode": false,
    "flag": "🇷🇪"
  },
  {
    "name": "Romania",
    "iso2": "ro",
    "dialCode": "40",
    "format": null,
    "isAreaCode": false,
    "flag": "🇷🇴"
  },
  {
    "name": "Russia",
    "iso2": "ru",
    "dialCode": "7",
    "priority": 0,
    "format": "+. (...) ...-..-..",
    "isAreaCode": false,
    "flag": "🇷🇺"
  },
  {
    "name": "Rwanda",
    "iso2": "rw",
    "dialCode": "250",
    "format": null,
    "isAreaCode": false,
    "flag": "🇷🇼"
  },
  {
    "name": "Saint Barthélemy",
    "iso2": "bl",
    "dialCode": "590",
    "priority": 1,
    "format": null,
    "isAreaCode": false,
    "flag": "🇧🇱"
  },
  {
    "name": "Saint Helena",
    "iso2": "sh",
    "dialCode": "290",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇭"
  },
  {
    "name": "Saint Kitts and Nevis",
    "iso2": "kn",
    "dialCode": "1869",
    "format": null,
    "isAreaCode": false,
    "flag": "🇰🇳"
  },
  {
    "name": "Saint Lucia",
    "iso2": "lc",
    "dialCode": "1758",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇨"
  },
  {
    "name": "Saint Martin",
    "iso2": "mf",
    "dialCode": "590",
    "priority": 2,
    "format": null,
    "isAreaCode": false,
    "flag": "🇲🇫"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "iso2": "pm",
    "dialCode": "508",
    "format": null,
    "isAreaCode": false,
    "flag": "🇵🇲"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "iso2": "vc",
    "dialCode": "1784",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇨"
  },
  {
    "name": "Samoa",
    "iso2": "ws",
    "dialCode": "685",
    "format": null,
    "isAreaCode": false,
    "flag": "🇼🇸"
  },
  {
    "name": "San Marino",
    "iso2": "sm",
    "dialCode": "378",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇲"
  },
  {
    "name": "São Tomé and Príncipe",
    "iso2": "st",
    "dialCode": "239",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇹"
  },
  {
    "name": "Saudi Arabia",
    "iso2": "sa",
    "dialCode": "966",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇦"
  },
  {
    "name": "Senegal",
    "iso2": "sn",
    "dialCode": "221",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇳"
  },
  {
    "name": "Serbia",
    "iso2": "rs",
    "dialCode": "381",
    "format": null,
    "isAreaCode": false,
    "flag": "🇷🇸"
  },
  {
    "name": "Seychelles",
    "iso2": "sc",
    "dialCode": "248",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇨"
  },
  {
    "name": "Sierra Leone",
    "iso2": "sl",
    "dialCode": "232",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇱"
  },
  {
    "name": "Singapore",
    "iso2": "sg",
    "dialCode": "65",
    "format": "+.. ....-....",
    "isAreaCode": false,
    "flag": "🇸🇬"
  },
  {
    "name": "Sint Maarten",
    "iso2": "sx",
    "dialCode": "1721",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇽"
  },
  {
    "name": "Slovakia",
    "iso2": "sk",
    "dialCode": "421",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇰"
  },
  {
    "name": "Slovenia",
    "iso2": "si",
    "dialCode": "386",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇮"
  },
  {
    "name": "Solomon Islands",
    "iso2": "sb",
    "dialCode": "677",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇧"
  },
  {
    "name": "Somalia",
    "iso2": "so",
    "dialCode": "252",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇴"
  },
  {
    "name": "South Africa",
    "iso2": "za",
    "dialCode": "27",
    "format": null,
    "isAreaCode": false,
    "flag": "🇿🇦"
  },
  {
    "name": "South Korea",
    "iso2": "kr",
    "dialCode": "82",
    "format": "+.. ... .... ....",
    "isAreaCode": false,
    "flag": "🇰🇷"
  },
  {
    "name": "South Sudan",
    "iso2": "ss",
    "dialCode": "211",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇸"
  },
  {
    "name": "Spain",
    "iso2": "es",
    "dialCode": "34",
    "format": "+.. ... ... ...",
    "isAreaCode": false,
    "flag": "🇪🇸"
  },
  {
    "name": "Sri Lanka",
    "iso2": "lk",
    "dialCode": "94",
    "format": null,
    "isAreaCode": false,
    "flag": "🇱🇰"
  },
  {
    "name": "Sudan",
    "iso2": "sd",
    "dialCode": "249",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇩"
  },
  {
    "name": "Suriname",
    "iso2": "sr",
    "dialCode": "597",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇷"
  },
  {
    "name": "Swaziland",
    "iso2": "sz",
    "dialCode": "268",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇿"
  },
  {
    "name": "Sweden",
    "iso2": "se",
    "dialCode": "46",
    "format": "+.. (..) ...-..-..",
    "isAreaCode": false,
    "flag": "🇸🇪"
  },
  {
    "name": "Switzerland",
    "iso2": "ch",
    "dialCode": "41",
    "format": "+.. .. ... .. ..",
    "isAreaCode": false,
    "flag": "🇨🇭"
  },
  {
    "name": "Syria",
    "iso2": "sy",
    "dialCode": "963",
    "format": null,
    "isAreaCode": false,
    "flag": "🇸🇾"
  },
  {
    "name": "Taiwan",
    "iso2": "tw",
    "dialCode": "886",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇼"
  },
  {
    "name": "Tajikistan",
    "iso2": "tj",
    "dialCode": "992",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇯"
  },
  {
    "name": "Tanzania",
    "iso2": "tz",
    "dialCode": "255",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇿"
  },
  {
    "name": "Thailand",
    "iso2": "th",
    "dialCode": "66",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇭"
  },
  {
    "name": "Timor-Leste",
    "iso2": "tl",
    "dialCode": "670",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇱"
  },
  {
    "name": "Togo",
    "iso2": "tg",
    "dialCode": "228",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇬"
  },
  {
    "name": "Tokelau",
    "iso2": "tk",
    "dialCode": "690",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇰"
  },
  {
    "name": "Tonga",
    "iso2": "to",
    "dialCode": "676",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇴"
  },
  {
    "name": "Trinidad and Tobago",
    "iso2": "tt",
    "dialCode": "1868",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇹"
  },
  {
    "name": "Tunisia",
    "iso2": "tn",
    "dialCode": "216",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇳"
  },
  {
    "name": "Turkey",
    "iso2": "tr",
    "dialCode": "90",
    "format": "+.. ... ... .. ..",
    "isAreaCode": false,
    "flag": "🇹🇷"
  },
  {
    "name": "Turkmenistan",
    "iso2": "tm",
    "dialCode": "993",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇲"
  },
  {
    "name": "Turks and Caicos Islands",
    "iso2": "tc",
    "dialCode": "1649",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇨"
  },
  {
    "name": "Tuvalu",
    "iso2": "tv",
    "dialCode": "688",
    "format": null,
    "isAreaCode": false,
    "flag": "🇹🇻"
  },
  {
    "name": "U.S. Virgin Islands",
    "iso2": "vi",
    "dialCode": "1340",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇮"
  },
  {
    "name": "Uganda",
    "iso2": "ug",
    "dialCode": "256",
    "format": null,
    "isAreaCode": false,
    "flag": "🇺🇬"
  },
  {
    "name": "Ukraine",
    "iso2": "ua",
    "dialCode": "380",
    "format": "+... (..) ... .. ..",
    "isAreaCode": false,
    "flag": "🇺🇦"
  },
  {
    "name": "United Arab Emirates",
    "iso2": "ae",
    "dialCode": "971",
    "format": null,
    "isAreaCode": false,
    "flag": "🇦🇪"
  },
  {
    "name": "United Kingdom",
    "iso2": "gb",
    "dialCode": "44",
    "format": "+.. .... ......",
    "isAreaCode": false,
    "flag": "🇬🇧"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": false,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1907",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1205",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1251",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1256",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1334",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1479",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1501",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1870",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1480",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1520",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1602",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1623",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1928",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1209",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1213",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1310",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1323",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1408",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1415",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1510",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1530",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1559",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1562",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1619",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1626",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1650",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1661",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1707",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1714",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1760",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1805",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1818",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1831",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1858",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1909",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1916",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1925",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1949",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1951",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1303",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1719",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1970",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1203",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1860",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1202",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1302",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1239",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1305",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1321",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1352",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1386",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1407",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1561",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1727",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1772",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1813",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1850",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1863",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1904",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1941",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1954",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1229",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1404",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1478",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1706",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1770",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1912",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1808",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1319",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1515",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1563",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1641",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1712",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1208",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1217",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1309",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1312",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1618",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1630",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1708",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1773",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1815",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1847",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1219",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1260",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1317",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1574",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1765",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1812",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1316",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1620",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1785",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1913",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1270",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1502",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1606",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1859",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1225",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1318",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1337",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1504",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1985",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1413",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1508",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1617",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1781",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1978",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1301",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1410",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1207",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1231",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1248",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1269",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1313",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1517",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1586",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1616",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1734",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1810",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1906",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1989",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1218",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1320",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1507",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1612",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1651",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1763",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1952",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1314",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1417",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1573",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1636",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1660",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1816",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1228",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1601",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1662",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1406",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1252",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1336",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1704",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1828",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1910",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1919",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1701",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1308",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1402",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1603",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1201",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1609",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1732",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1856",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1908",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1973",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1505",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1575",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1702",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1775",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1212",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1315",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1516",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1518",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1585",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1607",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1631",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1716",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1718",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1845",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1914",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1216",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1330",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1419",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1440",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1513",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1614",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1740",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1937",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1405",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1580",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1918",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1503",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1541",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1215",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1412",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1570",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1610",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1717",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1724",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1814",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1401",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1803",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1843",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1864",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1605",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1423",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1615",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1731",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1865",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1901",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1931",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1210",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1214",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1254",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1281",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1325",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1361",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1409",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1432",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1512",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1713",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1806",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1817",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1830",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1903",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1915",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1936",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1940",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1956",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1972",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1979",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1435",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1801",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1276",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1434",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1540",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1703",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1757",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1804",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1802",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1206",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1253",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1360",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1425",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1509",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1262",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1414",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1608",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1715",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1920",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1304",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "United States",
    "iso2": "us",
    "dialCode": "1307",
    "priority": 0,
    "format": "+. (...) ...-....",
    "isAreaCode": true,
    "flag": "🇺🇸"
  },
  {
    "name": "Uruguay",
    "iso2": "uy",
    "dialCode": "598",
    "format": null,
    "isAreaCode": false,
    "flag": "🇺🇾"
  },
  {
    "name": "Uzbekistan",
    "iso2": "uz",
    "dialCode": "998",
    "format": null,
    "isAreaCode": false,
    "flag": "🇺🇿"
  },
  {
    "name": "Vanuatu",
    "iso2": "vu",
    "dialCode": "678",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇺"
  },
  {
    "name": "Vatican City",
    "iso2": "va",
    "dialCode": "39",
    "priority": 1,
    "format": "+.. .. .... ....",
    "isAreaCode": false,
    "flag": "🇻🇦"
  },
  {
    "name": "Venezuela",
    "iso2": "ve",
    "dialCode": "58",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇪"
  },
  {
    "name": "Vietnam",
    "iso2": "vn",
    "dialCode": "84",
    "format": null,
    "isAreaCode": false,
    "flag": "🇻🇳"
  },
  {
    "name": "Wallis and Futuna",
    "iso2": "wf",
    "dialCode": "681",
    "format": null,
    "isAreaCode": false,
    "flag": "🇼🇫"
  },
  {
    "name": "Yemen",
    "iso2": "ye",
    "dialCode": "967",
    "format": null,
    "isAreaCode": false,
    "flag": "🇾🇪"
  },
  {
    "name": "Zambia",
    "iso2": "zm",
    "dialCode": "260",
    "format": null,
    "isAreaCode": false,
    "flag": "🇿🇲"
  },
  {
    "name": "Zimbabwe",
    "iso2": "zw",
    "dialCode": "263",
    "format": null,
    "isAreaCode": false,
    "flag": "🇿🇼"
  }
];
